import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import { getToken, GET_PAYMENT_DETAILS } from "../../Utils/types";

export const getPaymentDetailsAction = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/PaymentDetails/GetPaymentDetails`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PAYMENT_DETAILS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYMENT_DETAILS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const updatePaymentDetailsAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/PaymentDetails/AddUpdatePaymentDetails`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Details updated successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};
